import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import PopUp from '../../../../Shared/Popup/PopUp';
import Config from '../../../../../Config';

const SuperWifi = (props) => {
    const [isDisplayPopup, setIsDisplayPopup] = useState(false);
    const [currentLoadingItem, setCurrentLoadingItem] = useState('');

    return (
        <div className='super-wifi-wrapper'>

            {
                props.orderType == 'replace' ? (
                    <>
                        <div className='super-wifi-item-wrapper' key='keep'>
                            <input type='radio' name='super-wifi' className='input-radio' id='input-radio-keep' />
                            <label className='super-wifi-item' htmlFor={'input-radio-keep'} onClick={() => selectSuperWifi({ name: 'keep' }, 'keep')}>
                                {
                                    props.isLoadingShoppingCart && currentLoadingItem == 'keep' &&
                                    <div className='super-wifi-loader'></div>
                                }
                                <div className='details-wrapper'>
                                    <div className='super-wifi-details'>
                                        אין בעיה, לא יכול לוותר על סופר WiFi
                                    </div>
                                </div>
                            </label>
                        </div>
                        <div className='super-wifi-item-wrapper' key='lead'>
                            <input type='radio' name='super-wifi' className='input-radio' id='input-radio-lead' />
                            <label className='super-wifi-item' htmlFor={'input-radio-lead'} onClick={() => selectSuperWifi({ name: 'lead' }, 'lead')}>
                                {
                                    props.isLoadingShoppingCart && currentLoadingItem == 'lead' &&
                                    <div className='super-wifi-loader'></div>
                                }
                                <div className='details-wrapper'>
                                    <div className='super-wifi-details'>
                                        רגע, אשמח לשוחח עם נציג ולשאול שאלות
                                    </div>
                                </div>
                            </label>
                        </div>
                    </>
                ) : (
                    <>
                        {
                            props.superWifiList && props.superWifiList.map(function (item, index) {
                                return (
                                    <div className='super-wifi-item-wrapper' key={index}>
                                        {
                                            item.cmsData?.labelText &&
                                            <div className='super-wifi-label'> {item.cmsData?.labelText} </div>
                                        }

                                        <input type='radio' name='super-wifi' className='input-radio' id={`input-radio-${index}`} />
                                        <label className='super-wifi-item' htmlFor={`input-radio-${index}`} onClick={() => selectSuperWifi(item, item.name)}>
                                            {
                                                props.isLoadingShoppingCart && currentLoadingItem == item.name &&
                                                <div className='super-wifi-loader'></div>
                                            }
                                            <div className='details-wrapper'>
                                                <div className='super-wifi-details'>
                                                    {item.billDescription}
                                                </div>
                                                <div className='super-wifi-price'> {parseFloat(item.price) > 0 ? `₪${item.price} לחודש` : 'ללא עלות'} </div>
                                            </div>
                                            {
                                                item.cmsData?.description &&
                                                <div className='super-wifi-description'> {item.cmsData?.description} </div>
                                            }
                                        </label>
                                    </div>
                                );
                            })
                        }

                        <div className='super-wifi-item-wrapper' key='none'>
                            <input type='radio' name='super-wifi' className='input-radio' id='input-radio-none' />
                            <label className='super-wifi-item' htmlFor={'input-radio-none'} onClick={() => selectSuperWifi({ name: '' }, 'none')}>
                                {
                                    props.isLoadingShoppingCart && currentLoadingItem == 'none' &&
                                    <div className='super-wifi-loader'></div>
                                }
                                <div className='details-wrapper'>
                                    <div className='super-wifi-details'>
                                        אין לי צורך, תודה
                                    </div>
                                </div>
                            </label>
                        </div>
                    </>
                )
            }

            {props.error && <p className='error-msg'>{props.error}</p>}

            {
                props.superWifiPopupText &&
                <div className='open-popup-link-wrapper'>
                    <a className='open-popup-link' href='#' onClick={() => setIsDisplayPopup(true)}>
                        <Image src={Config.epiBaseUrl + props.superWifiImage} />
                        {props.orderType == 'provide' && <> מתי כדאי להוסיף סופר WiFi? </>}
                    </a>

                    <PopUp showPopUp={isDisplayPopup} onClose={() => setIsDisplayPopup(false)} footerBtn={{ text: 'הבנתי, תודה', onBtnClick: handleClosePopup }}>
                        <div className='popup-title'>מתי כדאי להוסיף סופר WiFi?</div>
                        <div className='popup-image'><Image src={Config.epiBaseUrl + props.superWifiImage} /></div>
                        <div dangerouslySetInnerHTML={{ __html: props.superWifiPopupText }}></div>
                    </PopUp>
                </div>
            }

        </div>
    );

    function selectSuperWifi(item, name) {
        setCurrentLoadingItem(name);
        props.onSelectSuperWifi(item);
    }

    function handleClosePopup() {
        setIsDisplayPopup(false);
    }

};
export default SuperWifi;